import defaultHeaders from "../headers"
import { Response } from "../Model"
import client from "./client"

interface UserLoginResponse {
    hasDraft: boolean
    hasActiveMembership: boolean
    isTemporary: boolean
    firstTimeLogin: boolean
}

type GeneratePLSTokenResponse = string
type LoginRedirectPLSResponse = string

enum ImportConflict {
    EID_MISMATCH = `EID_MISMATCH`,
    USER_CONFLICT = `USER_CONFLICT`,
    EMAIL_CONFLICT = `EMAIL_CONFLICT`,
}

interface LoginResponse {
    firstTimeLogin: boolean;
    isTemporary: boolean;
    importConflict?: ImportConflict;
}

// Login PLS

export const postUserLogin = () => client.post<Response<UserLoginResponse>>(`login`, null, {headers: defaultHeaders()})

export const redirectToPLS = () => client.get<Response<LoginRedirectPLSResponse>>(`pls/pls-authorization-endpoint?deviceType=WEB`)

export const postUserLoginToPls = () => client.post<Response<LoginResponse>>(`login/pls`,{},{headers: defaultHeaders()})

export const generateTokenPls = (authCode: string) => client.post<Response<GeneratePLSTokenResponse>>(`pls/generate-myntuc-token/web/authcode`, {authCode: authCode} ,{headers: defaultHeaders()})

export const refreshToken = () => client.post<Response<GeneratePLSTokenResponse>>(`pls/refresh-myntuc-token`, {headers: defaultHeaders()})

export type { UserLoginResponse }